import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToWords'
})

export class NumberToWordsPipe implements PipeTransform {

  private numberWords = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
  ];

  private tensWords = [
    '',
    '',
    'Twenty',
    'Thirty',
    'Forty',
    'Fifty',
    'Sixty',
    'Seventy',
    'Eighty',
    'Ninety'
  ];

  private afterTenWords = [
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen'
  ];

  transform(value: any, args?: any): any {
    const amountString = String(value);
    if (amountString.length === 0) {
      return '';
    }

    const matches = amountString.match(/^([1-9]\d{0,10}|0+)(\.\d{1,2})?$/);
    // console.log('Matches are', matches);
    if (!matches) {
      return '';
    }

    let amountInWords = '';

    const rupeeValue = this.transformToWords(matches[1]);
    if (rupeeValue !== '') {
      amountInWords += rupeeValue + ' dollars';
    }

    if (matches[2]) {
      const paiseValue = this.transformToWords(matches[2].replace('.', ''));
      if (paiseValue !== '') {
        amountInWords += ' and ' + paiseValue + ' cents';
      }
    }

    if (amountInWords.length > 0) {
      amountInWords += ' only';
    }

    return amountInWords;

  }

  transformToWords(amount: string): string {
    const digits = new Array<number>(amount.length);
    for (let index = 0; index < amount.length; index++) {
      // console.log('Iteration ', index, amount.slice(index, index + 1), amount.length - index - 1);
      digits[amount.length - index - 1] = Number(amount.slice(index, index + 1));
    }
    // console.log('Sliced data for ', amount, digits);

    if (digits.length === 1) {
      return this.numberWords[digits[0]];
    }

    let amountInWords = '';

    if (digits.length >= 2) {
      amountInWords = this.handleTensAndUnits(digits[1], digits[0]);
    }

    if (digits.length >= 3) {
      const hundredsPart = this.handleHundreds(digits[2]);
      amountInWords = (hundredsPart === '' ? '' : hundredsPart + ' ') + (amountInWords === '' ? '' : ' ') + amountInWords;
    }

    if (digits.length >= 4 || digits.length >= 5) {
      const thousandsPart = this.handleTensAndUnits((digits.length >= 5 ? digits[4] : 0), digits[3]);
      amountInWords = (thousandsPart === '' ? '' : thousandsPart + ' Thousand ') + amountInWords;
    }

    if (digits.length >= 6 || digits.length >= 7) {
      const lakhsPart = this.handleTensAndUnits((digits.length >= 7 ? digits[6] : 0), digits[5]);
      amountInWords = (lakhsPart === '' ? '' : lakhsPart + ' Lakh ') + amountInWords;
    }

    if (digits.length >= 8) {
      const unitCroresPart = this.handleTensAndUnits((digits.length >= 9 ? digits[8] : 0), digits[7]);
      const hundredCrorePart = this.handleHundreds(digits.length >= 10 ? digits[9] : 0);
      const thousandCrorePart = this.handleTensAndUnits(0, digits.length === 11 ? digits[10] : 0);
      const croresPart = (thousandCrorePart === '' ? '' : thousandCrorePart + ' Thousand ')
        + (hundredCrorePart === '' ? '' : hundredCrorePart + ' ') + unitCroresPart;
      // + (unitCroresPart === '' ? '' : 'and ')
      amountInWords = (croresPart === '' ? '' : croresPart + ' Crore ') + amountInWords;
    }

    return amountInWords;
  }

  handleTensAndUnits(tensDigit: number, unitsDigit: number): string {
    let tensPart = '';
    let unitsPart = '';

    if (tensDigit === 1) {
      tensPart = this.afterTenWords[unitsDigit];
    } else {
      tensPart = this.tensWords[tensDigit];
      unitsPart = this.numberWords[unitsDigit];
    }
    // console.log('Words are', tensPart, unitsPart);
    return (tensPart.length > 0 && unitsPart.length > 0 ? tensPart + ' ' + unitsPart : tensPart + unitsPart);
  }

  handleHundreds(digit: number): string {
    const hundredsPart = this.numberWords[digit];
    return (hundredsPart === '' ? '' : hundredsPart + ' Hundred');
  }

  doTransform(num: number): string {
    return '';
  }
}
